import React, { useState } from "react";
import { fireConfetti } from "../../../utils/confetti";

export default function HomeActionCarousel({
  pendingDose,
  onApplyDose,
  waterCups = 0,
  waterGoal = 8,
  onAddWater,
  onOpenMeasures,
  onNavigateRoutine,
}) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [doseTaken, setDoseTaken] = useState(false);
  const [waterAdding, setWaterAdding] = useState(false);

  const totalSlides = 3;

  const handleToggleDose = async () => {
    const nextState = !doseTaken;
    setDoseTaken(nextState);
    if (nextState) {
      fireConfetti();
      if (onApplyDose && pendingDose) {
        onApplyDose(pendingDose);
      }
    }
  };

  const handleWaterClick = async () => {
    if (waterAdding) return;
    setWaterAdding(true);
    fireConfetti({ particleCount: 30, spread: 45 });
    if (onAddWater) {
      await onAddWater();
    }
    setTimeout(() => {
      setWaterAdding(false);
    }, 400);
  };

  return (
    <div className="space-y-2">
      {/* Header do Carrossel */}
      <div className="flex items-center justify-between px-1">
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-[#6C54D8] animate-pulse"></span>
          <span className="text-xs font-black text-gray-900 tracking-tight">
            Ações Imediatas
          </span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-[10px] font-bold text-purple-800 bg-purple-100/70 px-2 py-0.5 rounded-full">
            {currentSlide + 1} de {totalSlides} pendentes
          </span>
          <div className="flex gap-1">
            <button
              type="button"
              onClick={() => setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides)}
              className="w-6 h-6 rounded-full bg-white border border-purple-100 flex items-center justify-center text-gray-600 hover:text-purple-700 shadow-2xs text-xs font-bold active:scale-95"
            >
              ‹
            </button>
            <button
              type="button"
              onClick={() => setCurrentSlide((prev) => (prev + 1) % totalSlides)}
              className="w-6 h-6 rounded-full bg-white border border-purple-100 flex items-center justify-center text-gray-600 hover:text-purple-700 shadow-2xs text-xs font-bold active:scale-95"
            >
              ›
            </button>
          </div>
        </div>
      </div>

      {/* Janela do Carrossel */}
      <div className="overflow-hidden rounded-3xl">
        <div
          className="flex transition-transform duration-300 ease-out"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {/* SLIDE 1: DOSE PENDENTE */}
          <div className="w-full flex-shrink-0">
            <div className="bg-white rounded-3xl p-3.5 border border-purple-100 shadow-xs flex items-center justify-between gap-3">
              <div className="flex items-center gap-3 min-w-0">
                <div
                  className={`w-11 h-11 rounded-2xl flex items-center justify-center text-lg flex-shrink-0 transition-all ${
                    doseTaken
                      ? "bg-emerald-100 border border-emerald-300 text-emerald-700"
                      : "bg-amber-50 border border-amber-200/70 text-amber-600"
                  }`}
                >
                  {doseTaken ? "✓" : "💊"}
                </div>
                <div className="min-w-0">
                  <span
                    className={`px-2 py-0.5 rounded-md text-[9px] font-black uppercase tracking-wider block w-fit ${
                      doseTaken
                        ? "bg-emerald-200 text-emerald-900"
                        : "bg-amber-100 text-amber-800"
                    }`}
                  >
                    {doseTaken
                      ? "CONCLUÍDO • TOMADO"
                      : pendingDose?.time
                      ? `PROGRAMADO • ${pendingDose.time}`
                      : "PROGRAMADO • HOJE"}
                  </span>
                  <h4
                    className={`text-sm font-black text-gray-900 leading-tight truncate mt-1 ${
                      doseTaken ? "line-through text-gray-400" : ""
                    }`}
                  >
                    {pendingDose?.medicationName ||
                      pendingDose?.name ||
                      "Tirzepatida (Dose Semanal)"}
                  </h4>
                  <p className="text-[11px] font-medium text-gray-500 truncate">
                    {doseTaken
                      ? "Dose registrada com sucesso!"
                      : pendingDose?.dosage
                      ? `${pendingDose.dosage} • Tomar conforme rotina`
                      : "5.0 mg • Aplicação programada"}
                  </p>
                </div>
              </div>

              <button
                type="button"
                onClick={handleToggleDose}
                className={`w-12 h-12 rounded-2xl text-white flex items-center justify-center transition-all flex-shrink-0 active:scale-90 cursor-pointer ${
                  doseTaken
                    ? "bg-emerald-600 hover:bg-emerald-700 shadow-lg shadow-emerald-600/25"
                    : "bg-[#5B38C2] hover:bg-[#4A2E99] shadow-lg shadow-purple-600/25"
                }`}
                title={doseTaken ? "Desmarcar dose" : "Marcar como tomada"}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="3"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* SLIDE 2: HIDRATAÇÃO */}
          <div className="w-full flex-shrink-0">
            <div className="bg-white rounded-3xl p-3.5 border border-purple-100 shadow-xs flex items-center justify-between gap-3">
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-11 h-11 rounded-2xl bg-blue-50 border border-blue-200/70 flex items-center justify-center text-blue-600 flex-shrink-0 text-xl">
                  💧
                </div>
                <div className="min-w-0">
                  <span className="px-2 py-0.5 rounded-md bg-blue-100 text-blue-800 text-[9px] font-black uppercase tracking-wider block w-fit">
                    META DIÁRIA • {waterCups}/{waterGoal} COPOS
                  </span>
                  <h4 className="text-sm font-black text-gray-900 leading-tight truncate mt-1">
                    Hidratação do Dia
                  </h4>
                  <p className="text-[11px] font-medium text-gray-500 truncate">
                    {waterCups * 250}ml consumidos até agora
                  </p>
                </div>
              </div>

              <button
                type="button"
                onClick={handleWaterClick}
                disabled={waterAdding}
                className="px-3.5 h-12 rounded-2xl bg-[#0284C7] hover:bg-[#0369A1] text-white font-black text-xs flex items-center justify-center shadow-lg shadow-sky-600/20 active:scale-95 transition flex-shrink-0 cursor-pointer gap-1"
              >
                <span>+</span> 250ml
              </button>
            </div>
          </div>

          {/* SLIDE 3: PESO & BIOMETRIA */}
          <div className="w-full flex-shrink-0">
            <div className="bg-white rounded-3xl p-3.5 border border-purple-100 shadow-xs flex items-center justify-between gap-3">
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-11 h-11 rounded-2xl bg-purple-50 border border-purple-200/70 flex items-center justify-center text-purple-600 flex-shrink-0 text-xl">
                  ⚖️
                </div>
                <div className="min-w-0">
                  <span className="px-2 py-0.5 rounded-md bg-purple-100 text-purple-800 text-[9px] font-black uppercase tracking-wider block w-fit">
                    ACOMPANHAMENTO
                  </span>
                  <h4 className="text-sm font-black text-gray-900 leading-tight truncate mt-1">
                    Registro de Peso
                  </h4>
                  <p className="text-[11px] font-medium text-gray-500 truncate">
                    Mantenha sua evolução atualizada
                  </p>
                </div>
              </div>

              <button
                type="button"
                onClick={onOpenMeasures}
                className="px-3.5 h-12 rounded-2xl bg-[#6C54D8] hover:bg-[#5B38C2] text-white font-black text-xs flex items-center justify-center shadow-lg shadow-purple-600/20 active:scale-95 transition flex-shrink-0 cursor-pointer"
              >
                + Registrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
